/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useRef } from 'react';

/**
 * A React hook that throttles a function.
 *
 * @param callback - The function to throttle.
 * @param delay - The time (in milliseconds) to throttle the function.
 * @returns A throttled version of the function.
 */
export function useThrottle<T extends (...args: any[]) => void>(callback: T, delay: number): T {
  const lastCall = useRef<number>(0);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();
      if (now - lastCall.current >= delay) {
        lastCall.current = now;
        callback(...args);
      }
    },
    [callback, delay],
  ) as T;
}
